/**
 * Vue Router 配置
 *
 * 功能：
 * - 路由实例创建
 * - 路由守卫配置
 * - 动态路由加载
 */
import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from "vue-router";
import { constantRoutes } from "./constant-routes";

/**
 * 创建路由实例
 */
const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  scrollBehavior: () => ({ top: 0 }),
});

/**
 * 重置路由
 * 用于登出后清除动态添加的路由
 */
export function resetRouter() {
  const newRouter = createRouter({
    history: createWebHistory(),
    routes: constantRoutes,
  });
  (router as any).matcher = (newRouter as any).matcher;
}

/**
 * 动态添加路由
 */
export function addRoutes(routes: RouteRecordRaw[]) {
  // 移除占位的根路由，避免与动态布局路由冲突导致卡在加载页
  if (router.hasRoute("Root")) {
    router.removeRoute("Root");
  }

  routes.forEach((route) => {
    router.addRoute(route);
  });
}

// 配置路由守卫
export default router;
